<template>
<el-dialog title="查看详情" :visible.sync="dialogFormVisible" width="30%">
    <div>
        <div class="schedule_details_box" v-for="(item, index) in detailList" :key="index">
            <div class="schedule_title">
                <!-- 档期/订单 -->
                <span v-if="item.type =='1'">{{dictionary.getPickerTitle('news_type',item.news_type)}}</span>
                <span v-else>档期</span>
                <span v-if="item.type == '2'">
                    <span class='edite_btn' @click="openDialog(item,hallid,'edit')">编辑</span>
                    <span class='del_btn' @click="remove(item,index)">删除</span>
                </span>
            </div>
            <div class="schedule_item">
                <div class="schedule_name">信息类型：{{dictionary.getPickerTitle('news_type',item.news_type)}}</div>
                <div class="schedule_name">签单人：{{item.user}}</div>
            </div>
            <div class="schedule_item">

                <div class="schedule_name">餐标：{{item.table_price}}</div>
                <div class="schedule_name">桌数：{{item.table_amount}}</div>
            </div>

            <div class="schedule_item">
                <div class="schedule_name">创建时间：{{item.create_time}}</div>
                <div class="schedule_name">宴会类型： {{dictionary.convertBanquetTypeToStr(item.banquet_type)}}</div>
            </div>
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button @click="submit" type="primary">确 定</el-button>
    </div>
    <add-schedule ref="addSchedule" :parent="_self" />
</el-dialog>
</template>

<script>
import dictionary from '@/utils/dictionary.js';
import addSchedule from './add'; //   当前档期查询
export default {
    components: {
        addSchedule,
    },
    props: {
        detailType: {},
    },
    data() {

        return {
            halltitle: "",
            hotelTitle: '',
            formLabelWidth: 80,
            dialogFormVisible: false,
            detailList: [],
            hallid: ''
        };
    },
    created() {
        detailList: this.detailList
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    methods: {
        //编辑婚礼档期
        openDialog(item, hallid, type) {
            if (this.$refs.addSchedule) {
                this.$refs.addSchedule.editDilog(item, hallid, type)
            } else {
                this.$nextTick(function () {
                    this.$refs.addSchedule.editDilog(item, hallid, type)
                })
            }
        },
        showDetailDialog(hallId, year, month, day) {
            this.dialogFormVisible = true;
            let query = {
                hall_id: hallId,
                year: year,
                month: month,
                day: day
            };
            this.hallid = hallId;
            let that = this;
            let url = '/api/order.schedule/read';
            that.$post(url, query).then(function (response) {
                that.detailList = [];
                that.detailList = response.data;
            });
        },
        remove(data, index) {
            let that = this;
            let url = '/api/order.schedule/delete';
            let query = {
                id: data.id
            };
            that.$post(url, query).then(function (response) {
                if (response.code == 200) {
                    that.$message.success(response.msg);
                    that.detailList.splice(index, 1);
                    that.$parent.getSchedule();
                } else {
                    that.$message.error(response.msg);
                }

            });
        },
        submit() {
            this.dialogFormVisible = false
            this.$parent.getSchedule();
        }

    }
}
</script>

<style lang="less">
.schedule_details_box {
    width: 530px;
    margin: 0 auto;

    .schedule_title {
        background: cadetblue;
        height: 30px;
        line-height: 30px;
        padding-left: 10px;
        color: white;
        position: relative;

        .del_btn {
            position: absolute;
            right: 10px;
            cursor: pointer;
        }

        .edite_btn {
            position: absolute;
            right: 60px;
            cursor: pointer;
        }

    }

    .schedule_item {
        display: flex;
        align-items: center;

        .schedule_name {
            flex: 1;
            height: 35px;
            line-height: 35px;
        }
    }
}
</style>
